/* liftsets (BUILD-xlviii, homepage deferral): moves deferred section content into place.
   Each [data-lazy-section] host holds its heavy markup inside <template data-lazy-template> (nothing in a
   template is fetched or run until it is moved), so the first paint only carries the heading and the
   "View all" link. The move happens when the host enters an IntersectionObserver (600px rootMargin) or on
   window.lsIdle (first interaction / post-load idle), whichever comes first. Hosts without a template fall
   back to the Section Rendering API (fetch ?section_id=). Fires a bubbling 'ls:section:loaded' event with
   detail {id} afterwards. No-op in the theme editor (Shopify.designMode). Plain ES5, no dependencies. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  var hosts = document.querySelectorAll('[data-lazy-section]');
  if (!hosts.length) return;
  var io = null;

  function done(host) {
    host.removeAttribute('data-lazy-section');
    host.classList.remove('ls-lazy-slot');
    host.style.minHeight = '';
    var ev;
    try {
      ev = new CustomEvent('ls:section:loaded', { bubbles: true, detail: { id: host.getAttribute('data-section-id') } });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('ls:section:loaded', true, false, { id: host.getAttribute('data-section-id') });
    }
    host.dispatchEvent(ev);
  }

  function moveTemplate(host, tpl) {
    var frag = 'content' in tpl ? document.importNode(tpl.content, true) : null;
    if (frag) {
      tpl.parentNode.replaceChild(frag, tpl);
    } else {
      /* very old engines: parse the template's HTML instead */
      var div = document.createElement('div');
      div.innerHTML = tpl.innerHTML;
      while (div.firstChild) tpl.parentNode.insertBefore(div.firstChild, tpl);
      tpl.parentNode.removeChild(tpl);
    }
    done(host);
  }

  /* DOMParser marks inline scripts as already started; re-create them so app blocks still boot. */
  function reviveScripts(root) {
    var olds = root.querySelectorAll('script');
    for (var i = 0; i < olds.length; i++) {
      var o = olds[i], n = document.createElement('script');
      for (var a = 0; a < o.attributes.length; a++) n.setAttribute(o.attributes[a].name, o.attributes[a].value);
      n.text = o.text;
      o.parentNode.replaceChild(n, o);
    }
  }

  function fetchSection(host, id) {
    if (!window.fetch || !window.DOMParser) return;
    var url = location.pathname + '?section_id=' + encodeURIComponent(id);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section') || doc.body;
        while (host.firstChild) host.removeChild(host.firstChild);
        while (src.firstChild) host.appendChild(document.adoptNode(src.firstChild));
        reviveScripts(host);
        done(host);
      })
      .catch(function () { /* leave the heading + "View all" link in place */ });
  }

  function load(host) {
    if (host.getAttribute('data-lazy-loaded')) return;
    host.setAttribute('data-lazy-loaded', '1');
    if (io) io.unobserve(host);
    var tpl = host.querySelector('template[data-lazy-template]');
    if (tpl) moveTemplate(host, tpl);
    else fetchSection(host, host.getAttribute('data-lazy-section'));
  }

  function loadAll() {
    for (var i = 0; i < hosts.length; i++) load(hosts[i]);
  }

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) load(entries[i].target);
      }
    }, { rootMargin: '600px 0px' });
    for (var i = 0; i < hosts.length; i++) io.observe(hosts[i]);
  }

  if (typeof window.lsIdle === 'function') window.lsIdle(loadAll);
  else if (!io) loadAll();
  else window.addEventListener('load', function () { setTimeout(loadAll, 3000); }, { once: true });
})();
